import CustomModal from "../CustomModal";

const DisableStaffModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  handleDisableUser,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Disable Admin Modal"
      className="delete-modal"
    >
      {selectedAdmin && (
        <div className="delete-modal-inner">
          <img
            src={`${process.env.PUBLIC_URL}/images/disable-modal-img.png`}
            alt="Disable user icon"
          />
          <p>Are you sure you want to disable this Staff profile?</p>
          <div className="delete-modal-button">
            <button
              style={{ backgroundColor: "#DD9828", color: "#FAFAFA" }}
              className="delete-btn1"
              onClick={handleDisableUser}
            >
              Disable
            </button>
            <button className="delete-btn2" onClick={onRequestClose}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default DisableStaffModal;
